import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {A11yModule} from '@angular/cdk/a11y';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {DragDropModule} from '@angular/cdk/drag-drop';
// import {PortalModule} from '@angular/cdk/portal';
import {ScrollingModule} from '@angular/cdk/scrolling';
// import {MatAutocompleteModule} from '@angular/material/autocomplete';
// import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
// import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
// import {MatChipsModule} from '@angular/material/chips';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
// import {MatDividerModule} from '@angular/material/divider';
// import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
// import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
// import {MatProgressBarModule} from '@angular/material/progress-bar';
// import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
// import {MatRadioModule} from '@angular/material/radio';
// import {MatSelectModule} from '@angular/material/select';
// import {MatSidenavModule} from '@angular/material/sidenav';
// import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
// import {MatSnackBarModule} from '@angular/material/snack-bar';
// import {MatSortModule} from '@angular/material/sort';
// import {CdkStepperModule} from '@angular/cdk/stepper';
// import {MatStepperModule} from '@angular/material/stepper';
// import {CdkTableModule} from '@angular/cdk/table';
// import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
// import {MatTooltipModule} from '@angular/material/tooltip';
// import {CdkTreeModule} from '@angular/cdk/tree';
// import {MatTreeModule} from '@angular/material/tree';
// import {OverlayModule} from '@angular/cdk/overlay';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { TaskListsComponent } from './tasklists/tasklists.component';
import { TasksComponent } from './tasks/tasks.component';
import { TasksFilterComponent } from './tasks-filter/tasks-filter.component';
import { TaskDetailsComponent} from './task-details/task-details.component';
import { SubtasksComponent } from './subtasks/subtasks.component';
import { TasksFilterButtonComponent } from './tasks-filter-button/tasks-filter-button.component';
import { TasksItemComponent } from './tasks-item/tasks-item.component';
import { NameDialogComponent } from './name-dialog/name-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    TaskListsComponent,
    TasksComponent,
    TasksFilterComponent,
    TaskDetailsComponent,
    SubtasksComponent,
    TasksFilterButtonComponent,
    TasksItemComponent,
    NameDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    A11yModule,
    ClipboardModule,
    DragDropModule,
    // MatAutocompleteModule,
    // MatBadgeModule,
    MatButtonModule,
    // MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    // MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    // MatDividerModule,
    // MatExpansionModule,
    MatFormFieldModule,
    // MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    // MatProgressBarModule,
    // MatProgressSpinnerModule,
    // MatRadioModule,
    MatRippleModule,
    // MatSelectModule,
    // MatSidenavModule,
    // MatSliderModule,
    MatSlideToggleModule,
    // MatSnackBarModule,
    // MatSortModule,
    // CdkStepperModule,
    // MatStepperModule,
    // CdkTableModule,
    // MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    // MatTooltipModule,
    // CdkTreeModule,
    // MatTreeModule,
    // OverlayModule,
    // PortalModule,
    ScrollingModule,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
